module.exports = __webpack_public_path__ + "img/fankui_banner.54daa2a7.jpg";